import { render } from "./typeWord.vue?vue&type=template&id=7179e515&scoped=true"
import script from "./typeWord.vue?vue&type=script&lang=js"
export * from "./typeWord.vue?vue&type=script&lang=js"

import "./typeWord.vue?vue&type=style&index=0&id=7179e515&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7179e515"]])

export default __exports__